import React, {createRef} from 'react';
import ReactToPrint from "react-to-print";
import {DownloadTableExcel} from 'react-export-table-to-excel';
import * as moment from 'moment-timezone';
import {Spin} from 'antd';
import './style.css';

class Print extends React.Component {
  constructor(props) {
    super(props);
    this.componentRef = createRef();
    this.tableRef = createRef();
  }

  componentDidMount() {
    const {match, fetch} = this.props;
    if(match.params && match.params.id) {
      fetch(match.params.id);
    }
    // console.log(isBlank);
  }

  render() {
    const {data, loading, authUser} = this.props;
    const {asset, schedules, servicePerson, supervisorName, hasProcessed, processedBy, processedOn} = data && data.pm || {};
    const tasks = data && data['pm'] && data['pm']['tasks'] || [];
    const meter = data && data['pm'] && data['pm']['meterReading'] || [];
    // const reading = meter.map(mtr => `${mtr.value} ${mtr.name}`);

    const groupedMeter = meter.reduce((acc, obj) => {
      const group = obj.scheduleNo;
      if(!acc[group]) {
        acc[group] = [];
      }
      acc[group].push(obj);
      return acc;
    }, {});
    const reading = [];
    for (const grp in groupedMeter) {
      const values = groupedMeter[grp].map(obj => `${obj.value}${obj.name}`);
      reading.push(`(${grp}) ${values.join(', ')}`);
    }

    let timeIntervals = [];
    schedules && schedules.map(si => {
      // timeIntervals = timeIntervals.concat(si.timeIntervals || []);
      timeIntervals = timeIntervals.concat(si.timeIntervals && si.timeIntervals.map(t => {
        return {
          ...t,
          ...{schedule: si.serviceIdentifierNo || '', scheduleId: si._id || null}
        }
      }) || []);
    });
    const date = processedOn || data && data['pm'] && data['pm']['createdAt'] || new Date();
    const nextDues = timeIntervals.map(interval => {
      const currentMeter = meter.filter(read => read.name === interval.name && interval.scheduleId === read.schedule);
      if(currentMeter && currentMeter.length) {
        if(interval.name === 'KM' || interval.name === 'HOUR') {
          return `(${interval.schedule}) ${(currentMeter[0].value > 0 ? currentMeter[0].value : interval.value) + interval.value} ${interval.name}`;
        } else {
          return '(' + interval.schedule + ') ' + moment(date).add(interval.value,
            `${interval.name.toLowerCase()}s`).format('DD-MM-YYYY');
        }
      }
    });

    const logo = authUser && authUser.organisation && authUser.organisation.logo;
    return (
      <div>
        {hasProcessed ? (<>
          <ReactToPrint
            trigger={() => <button>Print this out!</button>}
            content={() => this.componentRef.current}
          />
          <DownloadTableExcel
            filename="schedule"
            sheet="schedule"
            currentTableRef={this.tableRef.current}
          >
            <button> Export excel</button>
          </DownloadTableExcel>
          <p>&nbsp;</p>
          <Spin spinning={loading}>
            <div ref={this.componentRef} style={{alignContent: 'center'}}>
              <table border=".5px solid #OOO" style={{color: '#000'}} key={'table'} ref={this.tableRef}>
                <tbody>
                <tr style={{height: '80px'}} key={`header`}>
                  <td colSpan={2} style={{fontSize: '2em', textAlign: 'center'}} height="100%">
                    <img src={logo || '#'} height={'80px'}/>
                  </td>
                  <td style={{
                    fontSize: '1em',
                    textAlign: 'center'
                  }}>{authUser && authUser.organisation && authUser.organisation.name || ''}</td>
                  <td style={{fontSize: '1.5em', textAlign: 'center'}}
                      colSpan='2'>{asset && asset.assetModel && asset.assetModel.name || ''}</td>
                </tr>
                <tr key={`info`}>
                  <td
                    colSpan={2}>{asset && asset.location && asset.location.name || ''} / {asset && asset.client && asset.client.name || ''}</td>
                  <td>Asset Code : {asset && asset.assetCode || ''}</td>
                  <td>{moment(date).format('DD-MM-YYYY')}</td>
                  <td>
                    <table cellPadding={0} cellSpacing={0} border="0" width="100%">
                      <tr>
                        <td style={{borderRight: '.5px solid'}}>Alt No : {asset && asset.altName || '-'}</td>
                        <td> Code : {data && data['pm'] && data['pm'].code || '-'}</td>
                      </tr>
                    </table>

                  </td>
                </tr>
                <tr key={`ind`}>
                  <td colSpan='3' width="100%">
                    {
                      schedules && schedules.map((si, inx) => `${inx > 0 ? ' | ' : ''}${si && si.serviceIdentifierName || ''} (${si && si.serviceIdentifierNo || '-'})`)
                    }
                  </td>
                  <td colSpan='2' rowSpan={2} width="100%">
                    Current Meter : <br/>{
                    reading.join(' | ')
                  }
                  </td>
                </tr>
                <tr key={`due`}>
                  <td style={{fontWeight: 'bold'}} colSpan='3' width="100%">
                    Next Due : {nextDues.join(', ')}
                  </td>
                </tr>

                <tr style={{backgroundColor: '#DEE1E4'}} key={`task-head`}>
                  <td align={'center'}>Sl No</td>
                  <td align={'center'} colSpan={2}>Check Points</td>
                  {/*<td align={'center'}>&nbsp;</td>*/}
                  <td align={'center'}>Action</td>
                  <td align={'center'}>Remarks</td>
                </tr>
                {
                  tasks.map((task, index) => (
                    <tr key={`task${index}`}>
                      <td width="5%">{index + 1}</td>
                      <td width="45%"
                          colSpan={2}>{task && task.task && task.task.taskName || ''} [{task && task.task && task.task.taskCode}]
                        ({task && task.schedule && task.schedule.toString()})
                      </td>
                      <td width="10%">{(task && task.actionTaken) ? 'Done' : ''}</td>
                      <td width="40%">{task && task.remark || ''}</td>
                    </tr>
                  ))
                }
                {/*<tr key={`rmrk`}>*/}
                {/*<td colSpan='5' height="200px" style={{verticalAlign: 'top'}}>Remarks:</td>*/}
                {/*</tr>*/}
                <tr key={`person1`}>
                  <td height="50" colSpan='3'>Service Person : {servicePerson || ''}</td>
                  <td colSpan='2' height="50">Sign :</td>
                </tr>
                <tr key={`person2`}>
                  <td height="50" colSpan='3'>Supervisor : {supervisorName || ''}</td>
                  <td colSpan='2' height="50">Sign :</td>
                </tr>
                </tbody>
              </table>
            </div>
          </Spin></>) : <Spin spinning={loading}><h4>Not Processed yet!</h4></Spin>}
      </div>
    );
  }
}

export default Print;
